import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { Grid, Divider, Button, FormControl, InputLabel, Select, MenuItem, Switch } from '@material-ui/core'
import { Search, Edit, Delete } from '@material-ui/icons'
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { API, MISC } from '@const'
import { SingleConfirmMsgDialog, ConfirmMsgDialog } from '@msg'
import EventDialog from '@dialogs/event-dialog'
import EventDoppelgangerDialog from '@dialogs/event-doppelganger/index'
import * as utils from '@utils'
import Table from '@tables/table'
import PfSubPfMultiSelect from '@select/pf-sub-pf-multi-select'
import clsx from 'clsx'
import { FileCopy } from '@material-ui/icons';
import { TextField } from '@prototype'
import moment from 'moment'

const COMPONENT_GROUP = 'event_management';

class EventManagementPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'EventManagementPage')
        }
    }

    state = {
        searchType: MISC.EVENT_RED_PACKET,
        loading: false,
        showEventDoppelganger: false,
        eventDoppelganger: {},
        copyRow: [],
        searchMode: 'nameSearch',
        searchName: '',
        searchStatus: 'active',
        searchSubPfid: 'all',
        currency: 'all',
        subPfList: []
    }

    options = {}

    is_enable(fieldKey) {
        return {
            field: fieldKey,
            type: 'action',
            render: (rowData) => {
                return (
                    <Switch
                        checked={rowData[fieldKey]}
                        onChange={(event) => {
                            this.confirmDialog.OpenDialog({
                                type: 'info',
                                msg: this.t('confirmSwitchMsg'),
                                confirmParams: {
                                    rowData: rowData,
                                    isEnable: event.target.checked,
                                },
                                confirm: (params) => {
                                    this.setState({ loading: true })
                                    switch (rowData['type']) {
                                        case MISC.EVENT_RED_PACKET:
                                            utils.apiRequest(
                                                'put',
                                                API.RED_PACKET_STATUS,
                                                {
                                                    event_id: rowData.event_id,
                                                    is_active: params.isEnable
                                                },
                                                (_data) => {
                                                    this.setState({ loading: false })
                                                    this.confirmDialog.closeDialog()
                                                    this.queryData(true)
                                                },
                                                (_error) => {
                                                    this.setState({ loading: false })
                                                }
                                            )
                                            break
                                        case MISC.EVENT_DRAGON_TIGER_BOARD:
                                            utils.apiRequest(
                                                'put',
                                                API.EVENT_LIST_STATUS,
                                                {
                                                    event_id: rowData.event_id,
                                                    type: 'dt_board',
                                                    status: params.isEnable
                                                },
                                                (_data) => {
                                                    this.setState({ loading: false })
                                                    this.confirmDialog.closeDialog()
                                                    this.queryData(true)
                                                },
                                                (_error) => {
                                                    this.setState({ loading: false })
                                                }
                                            )
                                            break
                                        case MISC.EVENT_GIVE_FREE_GAME:
                                            utils.apiRequest(
                                                'put',
                                                API.EVENT_LIST_FREE_SPIN_STATUS,
                                                {
                                                    event_id: rowData['event_id'],
                                                    status: params.isEnable
                                                },
                                                (_data) => {
                                                    this.setState({ loading: false })
                                                    this.confirmDialog.closeDialog()
                                                    this.queryData(true)
                                                },
                                                (_error) => {
                                                    this.setState({ loading: false })
                                                }
                                            )
                                            break
                                        default:
                                    }
                                },
                            })
                        }}
                        value="Status"
                        color="primary"
                        inputProps={{ 'aria-label': 'Status' }}
                        disabled={this.operateState(rowData)}
                    />
                )
            },
        }
    }

    deleteAction() {
        return {
            field: 'delete',
            hideTitle: true,
            type: 'action',
            render: (rowData) => (
                <Button
                    style={{ minWidth: '72px' }}
                    onClick={() => {
                        this.confirmDialog.OpenDialog({
                            type: 'warn',
                            msg: this.t('confirmDeleteMsg'),
                            confirm: (_params) => {
                                this.setState({ loading: true })
                                switch (rowData['type']) {
                                    case MISC.EVENT_RED_PACKET:
                                        utils.apiRequest(
                                            'delete',
                                            API.RED_PACKET,
                                            { event_id: rowData['event_id'] },
                                            (_data) => {
                                                this.confirmDialog.closeDialog()
                                                this.queryData(true)
                                                this.setState({ loading: false })
                                            },
                                            (_error) => {
                                                this.setState({ loading: false })
                                            }
                                        )
                                        break
                                    case MISC.EVENT_DRAGON_TIGER_BOARD:
                                        utils.apiRequest(
                                            'delete',
                                            API.DRAGON_TIGER_BOARD,
                                            { event_id: rowData['event_id'] },
                                            (_data) => {
                                                this.confirmDialog.closeDialog()
                                                this.queryData(true)
                                            },
                                            (_error) => {
                                                this.setState({ loading: false })
                                            }
                                        )
                                        break
                                    case MISC.EVENT_GIVE_FREE_GAME:
                                        utils.apiRequest(
                                            'delete',
                                            API.GIVE_FREE_GAME,
                                            { event_id: rowData['event_id'] },
                                            (_data) => {
                                                this.confirmDialog.closeDialog()
                                                this.queryData(true)
                                            },
                                            (_error) => {
                                                this.setState({ loading: false })
                                            }
                                        )
                                        break
                                    default:
                                }
                            },
                        })
                    }}
                    color="primary"
                    className={this.props.classes.button}
                    disabled={utils.isDateAfter(utils.getCurrentUTCMoment(), utils.getMoment(rowData['start_at']))}>
                    <Delete />
                    {this.t('delete')}
                </Button>
            ),
        }
    }

    editAction() {
        return {
            field: 'edit',
            hideTitle: true,
            type: 'action',
            render: (rowData) => {
                return (
                    <>
                        <Button
                            style={{ minWidth: '72px' }}
                            onClick={() => {
                                this.dialog.OpenDialog('edit', rowData['event_id'], rowData['type'])
                            }}
                            color="primary"
                            className={this.props.classes.button}
                            disabled={this.operateState(rowData)}>
                            <Edit />
                            {this.t('edit')}
                        </Button>
                        <Button
                            style={{ minWidth: '72px' }}
                            onClick={() => {
                                const eventDoppelganger = {
                                    event_id: rowData['event_id'],
                                    type: rowData['type'],
                                    eventInfo: rowData
                                }
                                if (rowData['type'] === 'dragonTigerBoard') {
                                    eventDoppelganger.joinedGameCodeList = rowData['joined_game_code_list']
                                }
                                this.setState({
                                    showEventDoppelganger: true,
                                    eventDoppelganger
                                })
                            }}
                            color="primary"
                            className={clsx(this.props.classes.button, {
                                [this.props.classes.hide]: (rowData['type'] !== MISC.EVENT_RED_PACKET) && (rowData['type'] !== MISC.EVENT_DRAGON_TIGER_BOARD),
                            })}
                            disabled={this.operateState(rowData)}
                        >
                            <PersonAddIcon />
                            {this.t('doppelganger')}
                        </Button>
                        {rowData['type'] === MISC.EVENT_RED_PACKET && <Button
                            style={{ minWidth: '72px' }}
                            onClick={() => {
                                this.setState({
                                    copyRow: ['edit', rowData['event_id'], rowData['type']]
                                }, () => {
                                    const isCopy = this.state.copyRow.length > 0
                                    if (isCopy) {
                                        this.dialog.OpenDialog(this.state.copyRow[0], this.state.copyRow[1], this.state.copyRow[2], isCopy)
                                    }
                                    (
                                        this.state.copyRow.includes(undefined) ||
                                        this.state.copyRow.includes(null) ||
                                        this.state.copyRow.includes('')
                                    )
                                        ? utils.addToast(this.t('copy') + this.t('TransferRecordStatus.fail'), 'error')
                                        : utils.addToast(this.t('copy') + this.t('success'), 'success')
                                })
                            }}
                            color="primary"
                        >
                            <FileCopy />
                            {this.t('copy')}
                        </Button>}
                    </>
                )
            },
        }
    }

    columns = [
        {
            field: 'type',
            render: (rowData) => {
                return this.t('Event.' + rowData['type'])
            },
        },
        { field: 'name' },
        {
            field: 'currency',
            render: (rowData) => this.t(`Currency.${rowData['currency']}`),
        },
        {
            field: 'pf_sub_pf_list',
            type: 'action',
            render: (rowData) => (
                <Button
                    variant="contained"
                    color="primary"
                    className={this.props.classes.button}
                    onClick={() => {
                        this.singleConfirmDialog.OpenDialog({
                            type: this.t('pfSubPfList'),
                            msg: rowData['joined_sub_pf_list'].map((pfSubPfID) => utils.GeneratePfSubPfName(pfSubPfID)).join('\n'),
                        })
                    }}>
                    {this.t('view')}
                </Button>
            ),
        },
        {
            field: 'start_at',
            type: 'datetime',
        },
        {
            field: 'end_at',
            type: 'datetime',
            render: (rowData, display) => (
                <div style={rowData['is_expired'] ? { color: 'red' } : {}}>
                    {display + (rowData['is_expired'] ? ` (${this.t('isExpired')})` : ``)}
                </div>
            ),
        },
    ]

    redpacketColumns = [
        {
            field: 'type',
            render: (rowData) => {
                return this.t('Event.' + rowData['type'])
            },
        },
        { field: 'name' },
        {
            field: 'currency',
            render: (rowData) => this.t(`Currency.${rowData['currency']}`),
        },
        {
            field: 'pf_sub_pf_list',
            type: 'action',
            render: (rowData) => (
                <Button
                    variant="contained"
                    color="primary"
                    className={this.props.classes.button}
                    onClick={() => {
                        this.singleConfirmDialog.OpenDialog({
                            type: this.t('pfSubPfList'),
                            msg: rowData['joined_sub_pf_list'].map((pfSubPfID) => utils.GeneratePfSubPfName(pfSubPfID)).join('\n'),
                        })
                    }}>
                    {this.t('view')}
                </Button>
            ),
        },
        {
            field: 'start_at',
            type: 'datetime',
        },
        {
            field: 'end_at',
            type: 'datetime',
            render: (rowData, display) => (
                <div style={rowData['is_expired'] ? { color: 'red' } : {}}>
                    {display + (rowData['is_expired'] ? ` (${this.t('isExpired')})` : ``)}
                </div>
            ),
        },
        {
            field: utils.t('totalBet', 'EventAwardTable'),
            render: (rowData) => {
                return rowData['total_bet']
            },
        },
        {
            field: 'budget',
            render: (rowData) => {
                return rowData['budget']
            },
        },
        {
            field: 'total_issued_bonuses',
            render: (rowData) => {
                return (
                    <div style={{color: Number(rowData.total_issued_bonuses) > Number(rowData.budget * 0.70)  ? 'red' : ''}}>
                        { rowData['total_issued_bonuses'] }
                    </div>
                )
            },
        }
    ]

    componentDidMount() {
        if (utils.checkValid(COMPONENT_GROUP + '.edit')) {
            this.redpacketColumns.push(this.is_enable('is_active'), this.editAction())
            this.columns.push(this.is_enable('is_enable'), this.editAction())
        }

        if (utils.checkValid(COMPONENT_GROUP + '.delete')) {
            this.redpacketColumns.push(this.deleteAction())
            this.columns.push(this.deleteAction())
        }
    }

    actions = (() => {
        const data = []
        if (utils.checkValid(COMPONENT_GROUP + '.add')) {
            data.push({
                icon: 'add',
                text: 'add',
                isFreeAction: true,
                onClick: () => {
                    this.dialog.OpenDialog('add')
                   
                },
            })
        }

        return data
    })()

    operateState(data) {
        const { type, is_expired, is_enable, is_send_award } = data
        switch (type) {
            case MISC.EVENT_DRAGON_TIGER_BOARD:
                return is_expired && (!is_enable || is_send_award)
            case MISC.EVENT_RED_PACKET:
                    return is_expired && moment(utils.currentDatetime()).isAfter(moment(data.end_at).add('5', 'day')) // 結束後五天都還能檢視內容
            default:
                return is_expired && !is_enable
        }
    }

    queryData(hideSuccessToast) {
        this.table.SetLoading(true)

        const queryParams = {
            filter: this.pfSelect.state.currency !== 'all' ? 'currency' : 'all_currency',
            currency: this.pfSelect.state.currency !== 'all' ? this.pfSelect.state.currency : '',
        }

        const promiseList = []

        switch (this.state.searchType) {
            case 'all':
                promiseList.push(
                    new Promise((resolve) => {
                        this.queryRedPacketData(resolve, queryParams)
                    })
                )
                promiseList.push(
                    new Promise((resolve) => {
                        this.queryDragonTigerBoardData(resolve, queryParams)
                    })
                )
                promiseList.push(
                    new Promise((resolve) => {
                        this.queryGiveFreeGameData(resolve, queryParams)
                    })
                )

                break
            case MISC.EVENT_RED_PACKET:
                promiseList.push(
                    new Promise((resolve) => {
                        this.queryRedPacketData(resolve, queryParams)
                    })
                )

                break
            case MISC.EVENT_DRAGON_TIGER_BOARD:
                promiseList.push(
                    new Promise((resolve) => {
                        this.queryDragonTigerBoardData(resolve, queryParams)
                    })
                )

                break
            case MISC.EVENT_GIVE_FREE_GAME:
                promiseList.push(
                    new Promise((resolve) => {
                        this.queryGiveFreeGameData(resolve, queryParams)
                    })
                )

                break
            default:
        }

        Promise.all(promiseList).then((respList) => {
            const tableData = []
            let isAllSuccess = true

            respList.forEach((resp) => {
                if (Array.isArray(resp)) {
                    tableData.push(...resp)
                } else if (isAllSuccess) {
                    isAllSuccess = false
                }
            })

            if (isAllSuccess && !hideSuccessToast) utils.addToast(utils.getCodeMsg('0'), 'success')

            this.table.SetData(tableData)
        })
    }

    queryRedPacketData(resolve, queryParams) {
        utils.apiRequest(
            'get',
            API.RED_PACKET_LIST,
            queryParams,
            (data) => {
                data.forEach((item) => {
                    item.type = MISC.EVENT_RED_PACKET
                })
                switch (this.state.searchMode) {
                    case 'nameSearch':
                        resolve(data.filter((item) => item.name.includes(this.state.searchName)))
                        break;
                    case 'pfSearch':
                        resolve(data.filter((item) => {
                            return this.state.searchSubPfid === 'all' ? item : item.joined_sub_pf_list.includes(this.state.searchSubPfid)
                        }))
                        break;
                    case 'statusSearch':
                        resolve(data.filter((item) => item.is_active === (this.state.searchStatus === 'active' ? true : false)))
                        break;
                    default:
                        resolve(data)
                        break;
                }
            },
            (_err) => {
                resolve()
            },
            true
        )
    }

    queryDragonTigerBoardData(resolve, queryParams) {
        utils.apiRequest(
            'get',
            API.DRAGON_TIGER_BOARD_LIST,
            queryParams,
            (data) => {
                const tableData = []
                data['dt_board_event_list'].forEach((elem) => {
                    tableData.push({
                        type: MISC.EVENT_DRAGON_TIGER_BOARD,
                        event_id: elem['event_id'],
                        name: elem['event_name'],
                        event_name: elem['event_name'],
                        currency: elem['currency'],
                        joined_sub_pf_list: elem['joined_sub_pf_list'],
                        joined_game_code_list: elem['joined_game_code_list'],
                        is_enable: elem['is_enable'],
                        start_at: elem['start_at'],
                        end_at: elem['end_at'],
                        dragon_awards: elem['dragon_awards'],
                        dragon_threshold: elem['dragon_threshold'],
                        tiger_awards: elem['tiger_awards'],
                        tiger_threshold: elem['tiger_threshold'],
                        is_expired: elem['is_expired'],
                    })
                })

                resolve(tableData)
            },
            (_err) => {
                resolve()
            },
            true
        )
    }

    queryGiveFreeGameData(resolve, queryParams) {
        utils.apiRequest(
            'get',
            API.GIVE_FREE_GAME_LIST,
            queryParams,
            (data) => {
                const tableData = []
                data['free_spin_event_list'].forEach((elem) => {
                    tableData.push({
                        type: MISC.EVENT_GIVE_FREE_GAME,
                        event_id: elem['event_id'],
                        name: elem['name'],
                        currency: elem['currency'],
                        joined_sub_pf_list: elem['joined_sub_pf_list'],
                        joined_game_code_list: elem['joined_game_code_list'],
                        play_game_code_list: elem['play_game_code_list'],
                        is_enable: elem['is_enable'],
                        start_at: elem['start_at'],
                        end_at: elem['end_at'],
                        threshold: elem['threshold'],
                        is_expired: elem['is_expired'],
                        limit_prize_pf_account_count: elem['limit_prize_pf_account_count'],
                        limit_prize_pf_count: elem['limit_prize_sub_pf_count'],
                        limit_reset_cycle: elem['limit_reset_cycle_setting'],
                    })
                })

                resolve(tableData)
            },
            (_err) => {
                resolve()
            },
            true
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControl className={this.props.classes.formControl}>
                        <InputLabel>{this.t('searchType')}</InputLabel>
                        <Select
                            value={this.state.searchType}
                            onChange={(event) => {
                                this.setState({
                                    searchType: event.target.value,
                                })
                            }}
                        >
                            <MenuItem value={MISC.EVENT_RED_PACKET}>{this.t('Event.' + MISC.EVENT_RED_PACKET)}</MenuItem>
                            <MenuItem value={MISC.EVENT_DRAGON_TIGER_BOARD}>{this.t('Event.' + MISC.EVENT_DRAGON_TIGER_BOARD)}</MenuItem>
                            {utils.checkValid(COMPONENT_GROUP + '.view') && <MenuItem value={MISC.EVENT_GIVE_FREE_GAME}>{this.t('Event.' + MISC.EVENT_GIVE_FREE_GAME)}</MenuItem>}
                        </Select>
                    </FormControl>
                    <PfSubPfMultiSelect
                        onRef={(ref) => (this.pfSelect = ref)}
                        options={{ hidePfSubPf: true, hideAllPlatform: false }}
                        currencyOnChange={() => {
                            setTimeout(() => {
                                const subPfList = this.pfSelect?.handleTreeDataFilter().reduce((value, item) => {
                                    item.children.forEach((childItem) => {
                                        value.push(childItem)
                                    })
                                    return value
                                }, [])
                                this.setState({
                                    currency: this.pfSelect?.state?.currency,
                                    subPfList
                                })
                            })
                        }}
                    />
                    {this.state.searchType === MISC.EVENT_RED_PACKET && <FormControl className={this.props.classes.formControl}>
                        <InputLabel>{this.t('searchType')}</InputLabel>
                        <Select
                            value={this.state.searchMode}
                            onChange={(event) => {
                                this.setState({
                                    searchName: '',
                                    searchStatus: 'active',
                                    searchSubPfid: 'all',
                                    searchMode: event.target.value,
                                })
                            }}
                        >
                            {['nameSearch', 'pfSearch', 'statusSearch'].map((item) => {
                                return (
                                    <MenuItem key={item} value={item}>{this.t(item)}</MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>}
                    {(this.state.searchType === MISC.EVENT_RED_PACKET && this.state.searchMode === 'nameSearch') && (
                        <FormControl style={{ marginTop: '3px' }}>
                            <TextField
                                label={this.t('name')}
                                onChange={(event) => {
                                    this.setState({
                                        searchName: event.target.value,
                                    })
                                }}
                            />
                        </FormControl>
                    )}
                    {(this.state.searchType === MISC.EVENT_RED_PACKET && this.state.searchMode === 'pfSearch') && (
                        <FormControl className={this.props.classes.formControl}>
                            <InputLabel>{utils.t('platformName', 'AddPlatformDialog')}</InputLabel>
                            <Select
                                value={this.state.searchSubPfid}
                                onChange={(event) => {
                                    this.setState({
                                        searchSubPfid: event.target.value,
                                    })
                                }}
                            >
                                <MenuItem value={'all'}>{utils.t('allSubPlatform', 'PfSubPfSelect')}</MenuItem>
                                {this.state.subPfList.map((item) => {
                                    return (
                                        <MenuItem key={item.key} value={item.key}>{item.title}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    )}
                    {(this.state.searchType === MISC.EVENT_RED_PACKET && this.state.searchMode === 'statusSearch') && (
                        <FormControl className={this.props.classes.formControl}>
                            <InputLabel>{utils.t('eventRedemptionStatus', 'EventDialog')}</InputLabel>
                            <Select
                                value={this.state.searchStatus}
                                onChange={(event) => {
                                    this.setState({
                                        searchStatus: event.target.value,
                                    })
                                }}
                            >
                                {['active', 'close'].map((item) => {
                                    return (
                                        <MenuItem key={item} value={item}>{this.t(item)}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    )}
                    <Button variant="contained" color="primary" className={this.props.classes.button} onClick={() => this.queryData()}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search')}
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    {this.state.searchType === MISC.EVENT_RED_PACKET && <Table
                        ownerName="EventManagementPage"
                        actions={this.actions}
                        columns={this.redpacketColumns}
                        options={this.options}
                        onRef={(ref) => (this.table = ref)}
                    />
                    }
                    {this.state.searchType !== MISC.EVENT_RED_PACKET && <Table
                        ownerName="EventManagementPage"
                        actions={this.actions}
                        columns={this.columns}
                        options={this.options}
                        onRef={(ref) => (this.table = ref)}
                    />
                    }
                    <SingleConfirmMsgDialog onRef={(ref) => (this.singleConfirmDialog = ref)} />
                    <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} loading={this.state.loading} />
                    <EventDialog
                        confirmCallback={() => {
                            this.queryData(true)
                        }}
                        onRef={(ref) => (this.dialog = ref)}
                    />
                    {this.state.showEventDoppelganger && <EventDoppelgangerDialog
                        doppelganger={this.state.eventDoppelganger}
                        closeDialog={() => {
                            this.setState({
                                showEventDoppelganger: false
                            })
                        }}
                    />}
                </Grid>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        hide: {
            display: 'none'
        },
    }
}

EventManagementPage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
}

export default hoc(styles)(EventManagementPage)
